import type { InfoEvent, LogEvent } from '../events';

export type PageHideDeliveryReason = 'skip_next_cleanup';
export type PageHideDeliveryTreatment = 'control' | 'treatment';

export const TelemetryDeliveryLifecycleEventName = 'telemetry_delivery_lifecycle';

interface ReportDeliveryLifecycleInfoOptions {
  readonly apiCount: number;
  readonly attempts: number;
  readonly encodedBodySize: number;
  readonly eventInputType: 'Log';
  readonly outcome: 'pagehide_queue_observed';
  readonly persisted: boolean;
  readonly reason?: PageHideDeliveryReason;
  readonly resultCount: number;
  readonly skipAuthentication: true;
  readonly treatment: PageHideDeliveryTreatment;
}

type IsDeliveryLifecycleEventName = (eventName: string) => boolean;
const isDeliveryLifecycleEventName: IsDeliveryLifecycleEventName = (eventName) =>
  eventName === TelemetryDeliveryLifecycleEventName;

type IsProductLogEvent = (event: LogEvent) => boolean;
export const isProductLogEvent: IsProductLogEvent = ({ name }) => !isDeliveryLifecycleEventName(name);

type CreateDeliveryLifecycleInfoEvent = (options: ReportDeliveryLifecycleInfoOptions) => InfoEvent;
export const createDeliveryLifecycleInfoEvent: CreateDeliveryLifecycleInfoEvent = ({
  apiCount,
  attempts,
  encodedBodySize,
  eventInputType,
  outcome,
  persisted,
  reason,
  resultCount,
  skipAuthentication,
  treatment,
}: ReportDeliveryLifecycleInfoOptions) => {
  const properties: InfoEvent['properties'] = {
    type: eventInputType,
    attempts,
    data: JSON.stringify({
      treatment,
      apiCount,
      encodedBodySize,
      persisted,
    }),
    outcome,
    ...(reason && { reason }),
    resultCount,
  };

  return {
    type: 'Info',
    name: TelemetryDeliveryLifecycleEventName,
    occurredAt: Date.now().toString(),
    skipAuthentication,
    properties,
  };
};
